
import React from 'react';

const LoanDetailsModal = ({ isOpen, onClose, loanDetails }) => {
  if (!isOpen) return null; // Do not render if the modal is not open

  return (
    <div className="modal">
      <div className="modal-content">
        <div className="bg-headerBtn md:w-full p-2  md:pl-8 pl-4 text-left rounded-t-lg ">
          <div className="flex justify-between">
            <div>
              <h2 className="md:text-2xl text-lg text-white font-bold md:mb-2">
                View Your UPAS/LC
              </h2>
              <p className="md:mb-2 text-xs md:text-sm text-white">
                Quick, Easy, and Secure – Get the Funds You Need Fast
              </p>
            </div>

            {/* Close button */}
            <span
              className="close md:mr-4 mr-0 -mt-0 text-white text-2xl font-bold hover:text-btnHover"
              onClick={onClose}
            >
              &times;
            </span>
          </div>
        </div>

        {loanDetails ? (
          // <div className="p-8 lg:pl-40 lg:pr-40 space-y-4">
          //   <p>
          //     <strong>LC Applicant: </strong> {loanDetails.lc_applicant}
          //   </p>
          //   <p>
          //     <strong>Loan Amount:</strong> {loanDetails.amount}
          //   </p>
          //   <p>
          //     <strong>Lc Currency:</strong> {loanDetails.lc_currency}
          //   </p>
          //   <p>
          //     <strong>Lc Value:</strong> {loanDetails.lc_value}
          //   </p>

          //   <p>
          //     <strong>Issue Bank:</strong> {loanDetails.status}
          //   </p>
          //   <p>
          //     <strong>LC Maturity:</strong> {loanDetails.lc_maturity}
          //   </p>
          //   <p>
          //     <strong>Product Name:</strong> {loanDetails.product_name}
          //   </p>
          //   <p>
          //     <strong>Beneficiary:</strong> {loanDetails.beneficiary}
          //   </p>
          //   {/* <p>
          //     <strong>If Refinance:</strong> {loanDetails.if_Refinance}
          //   </p> */}
          //   <p>
          //     <strong>Tenor Required:</strong> {loanDetails.tenor_required}
          //   </p>
          // </div>
          <div className="xl:p-8 p-2 lg:pl-10 lg:pr-10  rounded-lg xl:space-y-6 space-y-2">
            <h2 className="text-2xl font-bold text-center xl:mb-6 mb-2 text-headerBtn">
              Details
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:gap-4 gap-2 xl:text-sm text-xs xl:h-auto h-72 overflow-y-auto capitalize">
              <div className="bg-gray-100 p-4 rounded-md flex gap-2">
                <strong className="block text-headerBtn">LC Applicant:</strong>
                <span>{loanDetails.lc_applicant}</span>
              </div>
              {/* <div className="bg-gray-100 p-4 rounded-md flex gap-2">
                <strong className="block text-headerBtn">Loan Amount:</strong>
                <span>{loanDetails.amount}</span>
              </div> */}
              <div className="bg-gray-100 p-4 rounded-md flex gap-2">
                <strong className="block text-headerBtn">LC Currency:</strong>
                <span>{loanDetails.lc_currency}</span>
              </div>
              <div className="bg-gray-100 p-4 rounded-md flex gap-2">
                <strong className="block text-headerBtn">LC Value:</strong>
                <span>{loanDetails.lc_value}</span>
              </div>
              <div className="bg-gray-100 p-4 rounded-md flex gap-2">
                <strong className="block text-headerBtn">Issue Bank:</strong>
                <span>{loanDetails.issue_bank}</span>
              </div>
              <div className="bg-gray-100 p-4 rounded-md flex gap-2">
                <strong className="block text-headerBtn">LC Maturity:</strong>
                <span>{loanDetails.lc_maturity}</span>
              </div>
              <div className="bg-gray-100 p-4 rounded-md flex gap-2">
                <strong className="block text-headerBtn">Product Name:</strong>
                <span>{loanDetails.product_name}</span>
              </div>
              {/* <div className="bg-gray-100 p-4 rounded-md flex gap-2">
                <strong className="block text-headerBtn">Beneficiary:</strong>
                <span>{loanDetails.beneficiary}</span>
              </div> */}
              <div className="bg-gray-100 p-4 rounded-md flex gap-2">
                <strong className="block text-headerBtn">
                  Tenor Required:
                </strong>
                <span>{loanDetails.tenor_required}</span>
              </div>
              <div className="bg-gray-100 p-4 rounded-md flex gap-2">
                <strong className="block text-headerBtn">Status:</strong>
                <span>{loanDetails.status}</span>
              </div>
            </div>
          </div>
        ) : (
          <p>Loading loan details...</p>
        )}
        {/* Close button */}
        <div className="flex items-center justify-center mb-6">
          <button
            onClick={onClose}
            type="button"
            className="border-headerBtn border-2 text-headerBtn text-xs md:text-sm md:py-2 py-1 md:px-6 px-2 rounded-lg hover:bg-btnHover hover:text-white "
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoanDetailsModal;
